<template>
  <AppDialogContent v-model="givenValue" only-cancel-action>
    <template v-if="givenValue" #header>
      <h2 class="mb-5" style="font-size: 24px">
        {{ $t("events:venue.heading", "Venue address") }}
        <div style="font-size: 18px; font-weight: normal">
          <AppShowCountry :country="event.country" />
          {{ event.region ? event.region.name : "" }},
          {{ event.place }}
        </div>
      </h2>
    </template>
    <template v-if="givenValue">
      <section class="d-flex flex-row">
        <div class="mr-3" style="align-self: center">
          <v-icon>$iconMap</v-icon>
        </div>
        <div style="font-style: 16px">
          {{ event.venueAddress }}
          <br />
          {{ dmm }}
        </div>
        <div class="ml-3 my-auto">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                class="edit-green ma-auto"
                small
                v-bind="attrs"
                v-on="on"
                @click="copy"
              >
                <v-icon class="white--text" small>$iconPage</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("events:VenueCopy.tooltip") }}</span>
          </v-tooltip>
        </div>
      </section>
      <input ref="input" type="text" readonly style="height: 0" />
      <v-slide-y-transition>
        <div v-if="copied" class="primary-light pa-3 elevation-1 my-2">
          {{ $t("events:VenueCopy.success", "Address copied to clipboard") }}
        </div>
      </v-slide-y-transition>
      <GoogleMap
        v-if="givenValue"
        :position="position"
        :markers="[position]"
        :zoom="14"
        style-props="width: 100%;height: 24rem;"
        class="my-8"
      />
      <div class="mt-3" v-html="event.venueDirectionsInfo" />
    </template>
    <template #cancel>
      {{ $t("common:button.back") }}
    </template>
  </AppDialogContent>
</template>
<script>
import EventMapMixin from "./EventMapMixin.js";
import AppDialogContent from "@/components/elements/AppDialogContent.vue";
import GoogleMap from "@/components/elements/map/GoogleMap.vue";
import AppShowCountry from "@AppShows/AppShowCountry.vue";
export default {
  name: "GoogleMapModal",
  components: { AppDialogContent, GoogleMap, AppShowCountry },
  mixins: [EventMapMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    event: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      copied: false
    };
  },
  computed: {
    givenValue: {
      get() {
        return this.value;
      },
      set(val) {
        if (val == false) this.copied = false;
        this.$emit("input", val);
      }
    }
  },
  deactivated() {
    this.givenValue = false;
  }
};
</script>
